let site = "szene1"
let isVisited = true
import { getSiteId } from "./animation.js";

getSiteId(site, isVisited);